import script from "./CustomModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomModal.vue?vue&type=script&setup=true&lang=js"

import "./CustomModal.vue?vue&type=style&index=0&id=ebf57c3c&lang=scss&scoped=true"

import exportComponent from "/home/atsuser/aos/aos-ats-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ebf57c3c"]])

export default __exports__